export default __webpack_public_path__ + "static/media/logan.17e51bb8.png";